<template>
    <!--弹窗-->
    <el-dialog
        width="1000px"
        title="同步低价商城"
        :visible.sync="visible"
        :before-close="handleClose"
        append-to-body
    >

        <el-form
            ref="formData"
            :inline="true"
            :model="formData"
            class="synchronizationForm"
            size="mini"
            label-width="140px"
            label-position="top"
        >
            <el-form-item label="销售价格：" prop="selling_price">
                <el-input-number
                    v-model="formData.selling_price"
                    style="width: 180px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入销售价格"
                >
                </el-input-number>
            </el-form-item>

            <el-form-item label="分配人员" prop="userId" v-show="[0, 2].includes(this.type)">

                <el-radio :label="item.id" v-for="item in managerAnalysisList" :key="item.id" v-model="userId">
                    {{item.full_name }}
                </el-radio>

            </el-form-item>

        </el-form>


        <span slot="footer" class="dialog-footer">
            <el-button style="float:right;margin-left:6px;" size="mini" type="danger" plain
                       @click="handleClose()">关 闭</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm()"
                       :loading="loading">确 定</el-button>
        </span>

    </el-dialog>
</template>
<script>

import * as api from '@/api/advAnalys/advAnalys'
import {downloadFileUrl} from '@/utils/method'
import {
    sync_create_low_price_mall_create,
    sync_create_low_price_mall_sync_create_create
} from '@/api/advAnalys/advAnalys'
import store from '@/store'

export default {
    data() {
        return {
            managerAnalysisList: [],
            rules: {
                selling_price: [
                    {
                        required: true,
                        message: '请输入销售价格',
                        trigger: 'blur'
                    }
                ],
                userId: [
                    {
                        required: true,
                        message: '请选择分配人员',
                        trigger: 'blur'
                    }
                ]
            },

            visible: false,
            formData: {},
            loading: false,
            type: 0,
            userId: null,
        }
    },
    methods: {
        openModal(data, type = 0) {
            this.type = type
            this.formData = JSON.parse(JSON.stringify(data))
            this.getUserList()
            this.visible = true
        },
        getUserList() {
            if ([1, 3].includes(this.type)) {
                return
            }
            let tempPromise = null
            tempPromise = this.type === 0 ? api.manager_index_get_developer_list() : api.manager_index_get_operator_list()
            tempPromise.then(res => {
                if (res.code === 0) {
                    this.managerAnalysisList = res.data || []
                    console.log('this.managerAnalysisList', this.managerAnalysisList, this.type)

                    let id = this.type === 0 ? this.formData.developer_id : this.formData.operation_id
                    this.$set(this, 'userId', Number(id))

                } else {
                    this.$message({type: 'error', message: res.message})
                }
            })
        },
        submitForm() {
            if ([0, 2].includes(this.type) && !this.userId) {
                this.$message({type: 'error', message: '请选择分配人员'})
                return
            }
            this.$refs.formData.validate(valid => {
                if (valid) {
                    this.loading = true

                    const param = {
                        id: this.formData.id,
                        selling_price: this.formData.selling_price,
                        user_id: [1, 3].includes(this.type) ? store.getters.adminId : this.userId
                    }

                    let tempPromise = [0, 1].includes(this.type) ? api.sync_create_low_price_mall_create(param) : api.sync_create_low_price_mall_sync_create_create(param)

                    tempPromise.then((res) => {
                        if (res.success) {
                            this.$message.success(res.data)
                            this.handleClose(true)
                        } else {
                            this.$message.error(res.message)
                        }
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.$message({type: 'error', message: '请填写相应内容！'})
                }
            })

        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.visible = false
            this.loading = false
            this.formData = {}
            this.$emit('close-callback', isshow)
        }
    }
}
</script>
<style type="text/scss" lang="scss">
.wrapBox {
    width: 600px;
    margin-top: 10px;

    .bottomBox {
        margin-top: 17px;
        display: flex;
        justify-content: center;
    }
}

.download {
    display: flex;
    justify-content: center;
}

.top {
    margin: 0px auto 20px;
    width: 60%;
    display: flex;
    justify-content: space-between;
}

.synchronizationForm .el-radio {
    margin-bottom: 10px;
}

.dialog-footer {
    padding: 20px;
}
</style>

